/**
 * `StaleWhileRevalidate` Для данных, актуальность которых может быстро поменяться.
 * Всегда несвежие, обновляются в фоне и какое-то время хранятся в кеше
 *
 * `CacheFirst` Для данных, которые вряд ли изменятся за время сессии.
 *
 * `CacheFirstLong` Это CacheFirst с увеличенным временем кеша. Подходит для небольших размеров данных
 *
 * `NetworkOnly` Лучше использовать websocket.
 */
export const enum ApiCacheTimeMode {
	StaleWhileRevalidate = 'StaleWhileRevalidate',
	CacheFirst = 'CacheFirst',
	CacheFirstLong = 'CacheFirstLong',
	InfinityRequest = 'Infinity',
	NetworkOnly = 'NetworkOnly'
}
